import api from "../../http";

export default class ApiGame {
  static async getApiGame(url, id) {
    const params = {
      "id": id
    };
    return api.get(url, {params})
  }
}